module.exports = __webpack_public_path__ + "img/logo.20fa46d0.png";